import { SystemAdminNotification } from "src/globalTypes";
import { fetchAllNotificationsForUser } from "src/requests/notifications/requests";
import { Notifications } from "src/requests/notifications/types";
import { EwaThunk } from "src/store/types";
import {
  errorReceiveAllNotifications,
  receiveAllNotfications,
  requestFetchAllNotifications,
} from "../actionCreators";
import { removeReadNotifs } from "../utils";

const removeResolvedNotifications = ({
  systemNotifications,
  templateNotifications,
  systemAdminNotifications,
}: Notifications): Notifications => ({
  systemNotifications: systemNotifications.filter(removeReadNotifs),
  templateNotifications: templateNotifications.filter(removeReadNotifs),
  systemAdminNotifications:
    systemAdminNotifications?.filter(removeReadNotifs) ?? [],
});

export const fetchAllNotificationsThunk =
  (): EwaThunk =>
  async (dispatch): Promise<void> => {
    dispatch(requestFetchAllNotifications());

    try {
      const { data } = await fetchAllNotificationsForUser();
      const notifications = removeResolvedNotifications(data);
      dispatch(
        receiveAllNotfications({
          notifications,
        })
      );
    } catch (e) {
      // eslint-disable-next-line no-debugger
      debugger;
      dispatch(errorReceiveAllNotifications());
    }
  };
